import React from 'react';
import { Link } from 'react-router-dom';

import RecordBadge from '../common/RecordBadge';
import { cardOwnerOf } from '../cards/CardVisuals';
import { LIGHT_BULB } from '../icons';
import { chartFormWord } from '../../utils/chartForms';
import { chartFormGlyph } from './chartFormGlyphs';

/** Where a suggestion opens: the builder, pre-filled from its key (nothing saved). */
export const suggestionPath = (collectionId, key) => `/collections/${collectionId}/charts/new?suggestion=${encodeURIComponent(key)}`;

/**
 * Suggested charts on Reports (charts A10, plan §6.1): starting points made
 * from the collection's cards by the capability table
 * (chartBuilder/suggestions). A tier of its own, below the charts — or, while
 * there are none, under the empty state's one line. Each row is TEXT, as a
 * chart's row is (no suggestion is run): its name, the door into the builder
 * with the question filled in; the card it counts, as the card's badge; the
 * form it would be drawn as. Nothing is saved until the person chooses Save
 * there, and what they save is their own chart, as New chart's is.
 */
export default function ChartSuggestions({ suggestions, collectionId }) {
	if (!Array.isArray(suggestions) || !suggestions.length || !collectionId) return null;
	return (
		<div className='reports-tier reports-suggestions' data-tier='suggested'>
			<div className='micro-label reports-tier__label'>
				<LIGHT_BULB aria-hidden='true' className='reports-tier__glyph' />
				Suggested
			</div>
			<p className='reports-suggestions__hint'>Starting points made from your cards. Nothing is saved until you choose Save.</p>
			<ul className='reports-list'>
				{suggestions.map((suggestion) => {
					const Glyph = chartFormGlyph(suggestion.form);
					const card = suggestion.card;
					return (
						<li className='reports-row reports-row--suggestion' key={suggestion.key} data-suggestion={suggestion.key}>
							<div className='reports-row__main'>
								<Link className='reports-row__name' to={suggestionPath(collectionId, suggestion.key)}>{suggestion.name}</Link>
								<div className='reports-row__meta'>
									{card ? (
										<RecordBadge kind='card' record={card} title={card.name || 'Card'} size='sm' collection={cardOwnerOf(card)} className='reports-row__card' />
									) : null}
									<span className='reports-row__form'>
										<Glyph aria-hidden='true' className='reports-row__form-glyph' />
										{chartFormWord(suggestion.form)}
									</span>
								</div>
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
}
